<template>
  <div>
    <!-- <v-container> -->
      <v-navigation-drawer :style="`z-index: ${zIndex?zIndex:'999'};`"   right fixed location="bottom" :value="isVisible" :width="width">
        <div class="pa-2">
          <v-toolbar absolute flat height="70" width="100%">
            <v-toolbar-title>{{title || ""}}</v-toolbar-title>
            <v-spacer />
            <v-btn icon @click="handleClose"><v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>
          <component
          v-if="childMetaData"
            style="padding-top:41px"
            :is="childMetaData.componentName"
            v-bind="childMetaData.props"
            :value="modelValue"
          />
        </div>
      </v-navigation-drawer>
    <!-- </v-container> -->
  </div>
</template>
<script lang="ts">
import { Component, Prop } from "vue-property-decorator";

import store, * as Store from "@/../src-gen/store";
import * as Data from "@/../src-gen/data";
import ModelVue from "./ModelVue";
import FDataTable from "./table/FDataTable.vue";
import FForm from "./form/FForm.vue";
import NotesList from "@/section/chppapp/views/NotesList.vue";

@Component({
  components: {
    FForm,
    FDataTable,
    NotesList
  },
})
export default class FDrawer extends ModelVue {
  // @Store.Getter.Spine.GenericStore.drawerContentInfo
  // drawerContentInfo: Data.Spine.DrawerContentInfo;

  
  @Prop({ default: () => {} })
  onClose: () => void


  minimized: boolean = false;
  
  @Prop({
    default: true
  })
  isVisible: boolean;
  
  @Prop()
  title?: string;

  @Prop()
  zIndex: string;

  @Prop({
    default: "500"
  })
  width: string;

  @Prop()
  subTitle: string;


  @Prop({
    default: () => {}
  })
  childMetaData: any;

  handleClose(val: boolean) {
      this.onClose()
  }
}
</script>

<style scoped>
.childCard {
  position: fixed;
  right: 0;
  width: 500px;
  height: 100vh;
  top: 0;
  transform: translateX(0);
  animation: slide 0.5s forwards;
  animation-delay: 2s;
}
</style>
